import React from "react";
import { View, Text, ScrollView } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { Image } from "expo-image";
import Images from "@/assets/images";
import { FontFamilies, Typography } from "@/constants/Typography";

export default function WelcomeSlide4() {
  return (
    <ScrollView
      style={styles.container}
      contentContainerStyle={styles.contentContainer}
      showsVerticalScrollIndicator={false}
    >
      {/* Title */}
      <Text style={styles.title}>Track and cancel your subscriptions.</Text>
      {/* Card list (giả lập bằng View rỗng) */}
      <View style={styles.cardList}>
        {/* Row 1 */}
        <View style={styles.cardRow}>
          <Image source={Images.logoUber} style={styles.logo} />
          <View style={styles.cardTextBox}>
            <Text style={styles.cardTitle}>Uber</Text>
            <Text style={styles.cardSubtitle}>$30/month</Text>
          </View>
          <Text style={styles.cancelText}>Cancel</Text>
        </View>
        {/* Row 2 */}
        <View style={styles.cardRow}>
          <Image source={Images.logoDisneyPlus} style={styles.logo} />
          <View style={styles.cardTextBox}>
            <Text style={styles.cardTitle}>Disney Plus</Text>
            <Text style={styles.cardSubtitle}>$8.99/month</Text>
          </View>
          <Text style={styles.cancelText}>Cancel</Text>
        </View>
        {/* Row 3 */}
        <View style={styles.cardRow}>
          <Image source={Images.logoSpotify} style={styles.logo} />
          <View style={styles.cardTextBox}>
            <Text style={styles.cardTitle}>Spotify</Text>
            <Text style={styles.cardSubtitle}>$14.99/month</Text>
          </View>
          <Text style={styles.cancelText}>Cancel</Text>
        </View>
        {/* Row 4 */}
        <View style={styles.cardRow}>
          <Image source={Images.logoMailchimp} style={styles.logo} />
          <View style={styles.cardTextBox}>
            <Text style={styles.cardTitle}>Mailchimp</Text>
            <Text style={styles.cardSubtitle}>$199/month</Text>
          </View>
          <Text style={styles.cancelText}>Cancel</Text>
        </View>
      </View>
      {/* Review box */}
      <View style={styles.reviewBox}>
        <Image source={Images.avatarRv4} style={styles.avatar} />
        <View style={styles.reviewContent}>
          <Text style={styles.stars}>★★★★★</Text>
          <Text style={styles.reviewText}>
            @saracoleman: &quot;I love how they find the claims for you and all
            you have to do is fill it out.&quot;
          </Text>
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    flexGrow: 1,
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontFamily: FontFamilies.InterTight.Medium,
    fontSize: 36,
    color: "#fff",
    textAlign: "left",
    width: "100%",
    paddingHorizontal: 16,
    marginBottom: 24,
  },
  cardList: {
    width: "92%",
    backgroundColor: "rgba(255,255,255,0.08)",
    borderRadius: 16,
    padding: 12,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: "#FFFFFF33",
  },
  cardRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: "rgba(255,255,255,0.08)",
  },
  cardTextBox: {
    flex: 1,
    marginLeft: 12,
  },
  cardTitle: {
    color: "#fff",
    fontFamily: FontFamilies.Inter.Medium,
    fontSize: 15,
  },
  cardSubtitle: {
    color: "#ffffff50",
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 10,
    marginTop: 2,
  },
  cancelText: {
    color: "#A3F2A3",
    fontFamily: FontFamilies.Inter.Medium,
    fontSize: 11,
    marginLeft: 12,
    textDecorationLine: "underline",
  },
  logo: {
    width: 32,
    height: 32,
  },
  avatar: {
    width: 36,
    height: 36,
    borderRadius: 18,
  },
  reviewBox: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "rgba(255,255,255,0.08)",
    borderRadius: 16,
    padding: 12,
    marginTop: 24,
    width: "90%",
    borderWidth: 1,
    borderColor: "#FFFFFF33",
    gap: 12,
  },
  reviewContent: {
    flex: 1,
  },
  stars: {
    color: "#FFD700",
    ...Typography.body.medium,
    marginBottom: 2,
  },
  reviewText: {
    color: "#fff",
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 13,
  },
});
